import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import SupportLayer from "./SupportLayer";


const SupportPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Sponsors" />

        {/* SupportLayer */}
        <SupportLayer />

      </MasterLayout>
    </>
  );
};

export default SupportPage;
